import Rotas from './routes/Rotas';

function App() {
  return (
    <div className="App">
      <Rotas />
    </div>
  );
}

export default App;
